var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 7L12.7936 4.76892C12.4726 4.1268 12.312 3.80573 12.0725 3.57116C11.8608 3.36373 11.6055 3.20597 11.3253 3.10931C11.0083 3 10.6494 3 9.93147 3H6.10918C4.98907 3 4.42902 3 4.0012 3.21799C3.62487 3.40973 3.31891 3.71569 3.12717 4.09202C2.90918 4.51984 2.90918 5.0799 2.90918 6.2V7M2.90918 7H18.1092C19.7893 7 20.6294 7 21.2712 7.32698C21.8356 7.6146 22.2946 8.07354 22.5822 8.63803C22.9092 9.27976 22.9092 10.1198 22.9092 11.8V16.2C22.9092 17.8802 22.9092 18.7202 22.5822 19.362C22.2946 19.9265 21.8356 20.3854 21.2712 20.673C20.6294 21 19.7893 21 18.1092 21H7.70918C6.02902 21 5.18894 21 4.54721 20.673C3.98272 20.3854 3.52378 19.9265 3.23616 19.362C2.90918 18.7202 2.90918 17.8802 2.90918 16.2V7ZM10.7593 11.7522C10.9355 11.2514 11.2833 10.829 11.741 10.56C12.1988 10.2909 12.737 10.1926 13.2603 10.2824C13.7836 10.3721 14.2583 10.6442 14.6002 11.0504C14.9422 11.4566 15.1293 11.9707 15.1285 12.5017C15.1285 14.0006 12.8802 14.75 12.8802 14.75M12.9092 17.75H12.9192",
    stroke: "#5C6469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0183272dc0dbe42a859928ae2b768244.svg";
export { ForwardRef as ReactComponent };